import { GroupBox } from 'react95';
import { useLocale } from '../i18n/LocaleContext';
import { Block, Link, SectionTitle } from './ui';

const Certificates = ({ data }) => {
  const { t } = useLocale();
  const labels = t.certificates;

  return (
    <>
      <SectionTitle>{labels.title}</SectionTitle>
      {data.certificates.map((cert) => (
        <Block key={`${cert.title}-${cert.date}`}>
          <GroupBox
            label={
              cert.link ? (
                <Link href={cert.link} target="_blank" rel="noopener noreferrer">
                  {cert.title}
                </Link>
              ) : (
                cert.title
              )
            }
          >
            <p>
              <strong>{labels.issuer}:</strong> {cert.issuer}
            </p>
            <p>
              <strong>{labels.date}:</strong> {cert.date}
            </p>
          </GroupBox>
        </Block>
      ))}
    </>
  );
};

export default Certificates;
